module.exports = __webpack_public_path__ + "img/Logo.6f5fceed.png";